import React from 'react';
import Wetter from '../components/Wetter';
import './home.css'; // gleiche Styles wie bei Home verwenden

function WetterNeupoella() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="wetter-neupoella-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="wetter-neupoella-heading">WETTER</h1>
        </div>

        <Wetter ort="neupoella" />
      </div>
    </div>
  );
}

export default WetterNeupoella;
